import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import CategoryCard from '../home/CategoryCard'
// Utils
import categoryPairs from '../landings/util/arraySplit'

interface CardCategoriesMobileProps
  extends React.HTMLAttributes<HTMLDivElement> {
  categories: string[]
  isLanding: boolean
}

export const CardCategoriesMobile = ({
  categories,
  isLanding,
}: CardCategoriesMobileProps) => {
  const length = categories.length

  return (
    <Swiper
      speed={1000}
      spaceBetween={10}
      initialSlide={0}
      grabCursor
      slidesPerView="auto"
    >
      {categoryPairs(categories)
        .map((c, i) => (
          <SwiperSlide key={i}>
            <CategoryCard c={c[0]} isLanding={isLanding} />
            <CategoryCard c={c[1]} isLanding={isLanding} />
          </SwiperSlide>
        ))
        .slice(0, length)}
    </Swiper>
  )
}
export default CardCategoriesMobile
